// Agrupa jugadas idénticas (mismo número, signo y monto) aplicadas a varios
// sorteos/horarios en un bloque compacto para la impresión térmica.
// Ej.: la misma jugada "35-JIR" a Bs 100 en 7 sorteos se imprime una sola vez
// con el bloque de horarios encima y el total (700,00) al lado.
export function groupTicketPlays(plays = [], lotteryMap = {}, sorteoMap = {}) {
  const groups = [];
  const index = new Map();
  for (const p of plays) {
    const amount = Number(p.amount_bs) || 0;
    const key = `${p.number}|${p.sign || ""}|${amount}`;
    let g = index.get(key);
    if (!g) {
      g = {
        key,
        number: p.number,
        sign: p.sign || "",
        amount_bs: amount,
        count: 0,
        total_bs: 0,
        entries: [],
      };
      index.set(key, g);
      groups.push(g);
    }
    const lot = lotteryMap[p.lottery_type_id];
    const sor = sorteoMap[p.sorteo_id];
    g.entries.push({
      lottery_name: lot?.name || "-",
      lottery_code: lot?.code || "",
      label: sor?.label || "",
      scheduled_at: sor?.scheduled_at || null,
    });
    g.count += 1;
    g.total_bs += amount;
  }
  return groups;
}

// Etiqueta corta de la jugada: "35-JIR" o "35".
export function playLabel(group) {
  return group.sign ? `${group.number}-${group.sign}` : `${group.number}`;
}
